"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsOverflowing = void 0;
var react_1 = require("react");
var resize_observer_polyfill_1 = __importDefault(require("resize-observer-polyfill"));
function useIsOverflowing(ref, dimension) {
    if (dimension === void 0) { dimension = 'horizontal'; }
    var _a = react_1.useState(false), isOverflowing = _a[0], setIsOverflowing = _a[1];
    react_1.useEffect(function () {
        var current = (ref !== null && ref !== void 0 ? ref : {}).current;
        var trigger = function () {
            setIsOverflowing(getIsOverflowing(current, dimension));
        };
        var observer = new resize_observer_polyfill_1.default(trigger);
        if (current) {
            observer.observe(current);
            trigger();
        }
        return function () { return observer.disconnect(); };
    });
    return isOverflowing;
}
exports.useIsOverflowing = useIsOverflowing;
var getIsOverflowing = function (element, dimension) {
    if (dimension === 'horizontal') {
        return element.scrollWidth > element.clientWidth;
    }
    else {
        return element.scrollHeight > element.clientHeight;
    }
};
//# sourceMappingURL=useIsOverflowing.js.map